var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "135px",
    height: "100px",
    viewBox: "0 0 135 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "404-error",
    transform: "translate(-691, -352)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(433, 292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_warning",
    transform: "translate(258, 60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.4684438,6.22547997 C69.4529684,-2.07800521 81.5508865,-2.0723137 86.5319459,6.22547823 L133.533022,84.4925408 C137.615652,91.2914415 132.692391,100 124.740306,100 L26.2596129,100 C18.3079735,100 13.3840714,91.291798 17.4671346,84.4925373 Z",
    id: "Combined-Shape",
    fill: "#330810"
  }), /*#__PURE__*/React.createElement("g", {
    id: "warning",
    fill: "#F20A46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5319459,6.22547823 L117.533022,84.4925408 C121.615652,91.2914415 116.692391,100 108.740306,100 L10.2596129,100 C2.3079735,100 -2.61592864,91.291798 1.46713456,84.4925373 L48.4684438,6.22547997 C53.4529684,-2.07800521 65.5508865,-2.0723137 70.5319459,6.22547823 Z M53.377561,9.16040017 L6.37650301,87.4274321 C4.56830432,90.4345538 6.74265901,94.2887268 10.2598488,94.2887268 L108.740306,94.2887268 C112.258532,94.2887268 114.431225,90.4333148 112.623629,87.4270019 L65.6228113,9.16036953 C62.8540632,4.54984276 56.1449077,4.55175613 53.377561,9.16040017 Z M59.4999594,69.7698566 C62.1236583,69.7698566 64.2491923,71.8935651 64.2491923,74.5115602 C64.2491923,77.1295553 62.1236583,79.2532637 59.4999594,79.2532637 C56.8762605,79.2532637 54.7507265,77.1295553 54.7507265,74.5115602 C54.7507265,71.8935651 56.8762605,69.7698566 59.4999594,69.7698566 Z M59.4999594,32.048518 C61.0811313,32.048518 62.3615041,33.3278462 62.3615041,34.9041546 L62.3615041,61.3090916 C62.3615041,62.8855454 61.0812216,64.1647283 59.4999594,64.1647283 C57.9187874,64.1647283 56.6384147,62.8854 56.6384147,61.3090916 L56.6384147,34.9041546 C56.6384147,33.3278462 57.9187874,32.048518 59.4999594,32.048518 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError);
export default __webpack_public_path__ + "static/media/ic_error.d2d77a6a4122d7e1d5b5d924c5fffce6.svg";
export { ForwardRef as ReactComponent };